import { getPageSource } from '@mc/track-event'
import { useTrackEmailCaptured } from '../../libs/client/marketing/useTrackEmailCaptured'

interface TrackProps {
  campaign?: string
  location?: string
  contentType?: string
  slug?: string
  category?: string
}

export const useTrackEmailCapture = (trackProps: TrackProps) => {
  const trackEmailCaptured = useTrackEmailCaptured()
  return async ({ email }: { email: string }) => {
    await trackEmailCaptured({
      event: 'Email Captured',
      properties: {
        campaign: trackProps?.campaign || 'sample',
        email,
        location: trackProps?.location,
        contentType: trackProps?.contentType,
        slug: trackProps?.slug,
        type: 'email',
        platform: 'web',
        category: trackProps?.category,
        page_source: getPageSource(),
      },
      integrations: { Iterable: true },
    })
  }
}
